export default "__VITE_ASSET__C_clUY_S__"